import request from "@/api";

export function getReportSale(data) {
    return request({
        url: '/api/report/getReportSale',
        method: 'post',
        data: data
    })
}

export function getReportGoodsRank(data) {
    return request({
        url: '/api/report/getReportGoodsRank',
        method: 'post',
        data: data
    })
}

export function getReportCatalogRank(data) {
    return request({
        url: '/api/report/getReportCatalogRank',
        method: 'post',
        data: data
    })
}

export function getReportBrandRank(data) {
    return request({
        url: '/api/report/getReportBrandRank',
        method: 'post',
        data: data
    })
}

export function getReportPriceRank(data) {
    return request({
        url: '/api/report/getReportPriceRank',
        method: 'post',
        data: data
    })
}

export function getReportSupplierRank(data) {
    return request({
        url: '/api/report/getReportSupplierRank',
        method: 'post',
        data: data
    })
}

export function exportGoodsRank(data) {
    return request({
        url: '/api/report/exportGoodsRank',
        method: 'post',
        responseType: 'blob',
        data: data
    })
}

export function exportCatalogRank(data) {
    return request({
        url: '/api/report/exportCatalogRank',
        method: 'post',
        responseType: 'blob',
        data: data
    })
}

export function exportBrandRank(data) {
    return request({
        url: '/api/report/exportBrandRank',
        method: 'post',
        responseType: 'blob',
        data: data
    })
}

export function exportPriceRank(data) {
    return request({
        url: '/api/report/exportPriceRank',
        method: 'post',
        responseType: 'blob',
        data: data
    })
}

export function exportSale(data) {
    return request({
        url: '/api/report/exportSale',
        method: 'post',
        responseType: 'blob',
        data: data
    })
}

export function exportSupplierRank(data) {
    return request({
        url: '/api/report/exportSupplierRank',
        method: 'post',
        responseType: 'blob',
        data: data
    })
}
